/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_DescriptionInputs */

const en_backend_session_description = /** @type {(inputs: Backend_Session_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dedicated EC2 instance is being provisioned for your session. Once ready, you can open it in a new tab to interact with the RMF stack directly.`)
};

const fr_backend_session_description = /** @type {(inputs: Backend_Session_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une instance EC2 dédiée est en cours de provisionnement pour votre session. Une fois prête, vous pourrez l'ouvrir dans un nouvel onglet pour interagir directement avec la stack RMF.`)
};

const ms_sg2_backend_session_description = /** @type {(inputs: Backend_Session_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu instance EC2 khusus sedang disediakan untuk sesi anda. Setelah sedia, anda boleh membukanya dalam tab baru untuk berinteraksi terus dengan stack RMF.`)
};

/**
* | output |
* | --- |
* | "A dedicated EC2 instance is being provisioned for your session. Once ready, you can open it in a new tab to interact with the RMF stack directly." |
*
* @param {Backend_Session_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_description = /** @type {((inputs?: Backend_Session_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_description(inputs)
	if (locale === "fr") return fr_backend_session_description(inputs)
	return ms_sg2_backend_session_description(inputs)
});